<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
              class="nav-link active"
              v-bind:href="'#t5' + rowData.docfis_id + ''"
              role="tab"
              data-toggle="tab"
              v-if="
              rowData.doc_fiscal_agr_log.length > 0
            "
          >
            <span class="nav-link-in">
               Erros
              <i class="fa fa-times"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <!--.tab-pane-->
        <div
            role="tabpanel"
            class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
            v-bind:id="'t5' + rowData.docfis_id + ''"
            v-if="
            rowData.doc_fiscal_agr_log.length > 0
          "
        >
          <table class="table-striped" id="mais">
            <thead>
            <tr>
              <th style="width: 10%">Entidade</th>
              <th data-toggle="true" style="width: 80%">Descrição</th>
              <th data-toggle="true" style="width: 3%">Qtde</th>
              <th data-toggle="true" style="width: 10%">Data Primeira e Ultima Ocorrencia</th>
            </tr>
            </thead>
            <tbody
                v-if="rowData.doc_fiscal_agr_log.length > 0"
                v-for="item in rowData.doc_fiscal_agr_log"
            >
            <tr class="bg-gray-light" style="display: table-row">
              <td>
                <span class="badge badge-primary" v-b-tooltip.hover.top="item.docfis_id">Geração Pre Fatura</span>
              </td>
              <td>
                {{ item.descr }}
              </td>
              <td>
                {{ item.qtde }}
              </td>
              <td>
                {{ formatDateHora(item.dt_primeira_ocorrencia) }}<br/>
                {{ formatDateHora(item.dt_ultima_ocorrencia) }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <MontagemCargaPartesEnvForm ref="montagemcargapartesenv">
      </MontagemCargaPartesEnvForm>
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import moment from "moment";
import MontagemCargaPartesEnvForm from "./MontagemCargaPartesEnvForm";

export default {
  components: {
    MontagemCargaPartesEnvForm,
  },
  data() {
    return {
      peso_bruto: "",
      visibleDetailRowsDoc: [],
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onDetailDoc(tabfrerot_id) {
      this.toggleDetailRowDoc(tabfrerot_id);
    },
    isVisibleDetailRowDoc(rowId) {
      return this.visibleDetailRowsDoc.indexOf(rowId) >= 0;
    },
    showDetailRowDoc(rowId) {
      if (!this.isVisibleDetailRowDoc(rowId)) {
        this.visibleDetailRowsDoc.push(rowId);
      }
    },
    hideDetailRowDoc(rowId) {
      if (this.isVisibleDetailRowDoc(rowId)) {
        this.visibleDetailRowsDoc.splice(
            this.visibleDetailRowsDoc.indexOf(rowId),
            1
        );
      }
    },
    toggleDetailRowDoc(rowId) {
      if (this.isVisibleDetailRowDoc(rowId)) {
        this.hideDetailRowDoc(rowId);
      } else {
        this.showDetailRowDoc(rowId);
      }
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
              /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
              "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    onEditaPartesEnv(data) {
      this.$refs.montagemcargapartesenv.onEdit(data);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null
          ? ""
          : moment(value, "YYYY/MM/DD HH:mm:ss").format(fmt);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
};
</script>